import React from "react";
import { useSelector } from "react-redux";
import { OpenRoutes, PrivateRoutes } from "routes/router";
import AppContext from "contexts/AppContext";
import Spinner from "elements/Spinner";
import auth from "services/auth";

export default function AuthGuard(props) {
  const [isReady, setIsReady] = React.useState(false);
  const isLoggedIn = useSelector((state) => state.userAuth.isAuthenticated);
  const { updateUserAuthStatus } = React.useContext(AppContext);

  React.useEffect(() => {
    let keepAliveInterval;

    const init = async () => {
      await updateUserAuthStatus();
      auth.checkLastUsed();
      keepAliveInterval = setInterval(() => {
        auth.updateLastUsed();
      }, 5000);
      setIsReady(true);
    };

    init();

    return () => {
      if (keepAliveInterval) {
        clearInterval(keepAliveInterval);
      }
    };
  }, []);

  if (!isReady) {
    return <Spinner />;
  }

  if (!isLoggedIn) {
    return <OpenRoutes {...props} />;
  }

  return <PrivateRoutes {...props} />;
}
